import React from 'react';

const VARIANTS = {
  primary: 'bg-brand-dark text-white shadow-soft hover:bg-brand-deep active:scale-[.99]',
  accent: 'bg-gradient-to-br from-brand-dark to-brand text-white shadow-card hover:shadow-lift active:scale-[.99]',
  outline: 'bg-white text-brand-dark border-2 border-brand-light hover:border-brand/40',
  ghost: 'bg-brand-light/70 text-brand-dark hover:bg-brand-light',
  danger: 'bg-white text-red-600 border-2 border-red-200 hover:bg-red-50',
  dangerSolid: 'bg-red-600 text-white hover:bg-red-700',
  blue: 'bg-gradient-to-br from-sky-600 to-sky-500 text-white shadow-card hover:shadow-lift',
};

const SIZES = {
  md: 'px-5 py-3 text-[15px] rounded-2xl',
  sm: 'px-3.5 py-2 text-[13px] rounded-xl',
  lg: 'px-6 py-3.5 text-base rounded-2xl',
};

export default function Button({
  as: As = 'button', variant = 'primary', size = 'md', loading, disabled, className = '',
  icon, children, fullWidth, ...rest
}) {
  const isDisabled = disabled || loading;
  return (
    <As
      className={[
        'inline-flex items-center justify-center gap-2 font-extrabold font-sans transition-all duration-150 select-none',
        VARIANTS[variant] || VARIANTS.primary,
        SIZES[size] || SIZES.md,
        fullWidth ? 'w-full' : '',
        isDisabled ? 'opacity-55 pointer-events-none' : 'cursor-pointer',
        className,
      ].join(' ')}
      disabled={As === 'button' ? isDisabled : undefined}
      aria-disabled={isDisabled || undefined}
      {...rest}
    >
      {loading ? (
        <span className="h-4 w-4 rounded-full border-2 border-white/40 border-t-white animate-spin" />
      ) : icon ? <span className="text-[1.05em] leading-none">{icon}</span> : null}
      {children}
    </As>
  );
}
